// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__2Ypph","container":"Breadcrumbs_container__Tzv1E","item":"Breadcrumbs_item__oFFgn","active":"Breadcrumbs_active__S32fV"};